import { render } from "./EWCard.vue?vue&type=template&id=b2847c56&scoped=true"
import script from "./EWCard.vue?vue&type=script&lang=js"
export * from "./EWCard.vue?vue&type=script&lang=js"

import "./EWCard.vue?vue&type=style&index=0&id=b2847c56&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2847c56"]])

export default __exports__